import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { formatDateISO, formatUsd } from "@kontextwerk/web-common";

import type { CostTimeseriesBucket } from "../lib/types";

interface Props {
  buckets: CostTimeseriesBucket[];
  height?: number;
}

export default function CostTrendChart({ buckets, height = 240 }: Props) {
  const data = buckets.map((b) => ({
    bucket: formatDateISO(b.bucket_start),
    total_cost_usd: b.total_cost_usd,
    total_calls: b.total_calls,
  }));
  if (data.length === 0) {
    return (
      <div className="text-sm text-kw-text-faint py-8 text-center">
        Keine Kosten-Daten im gewählten Zeitraum.
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 8, right: 24, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#1E2547" />
        <XAxis dataKey="bucket" tick={{ fontSize: 11, fill: "#94A3B8" }} />
        <YAxis
          tickFormatter={(v) => formatUsd(v)}
          tick={{ fontSize: 11, fill: "#94A3B8" }}
          width={92}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "#141A38",
            border: "1px solid #2A3358",
            fontSize: "12px",
          }}
          formatter={(value: number, name: string) =>
            name === "total_cost_usd" ? formatUsd(value) : value
          }
        />
        <Line
          type="monotone"
          dataKey="total_cost_usd"
          stroke="#7C5CFF"
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
